// Banques UEMOA par pays — taux INDICATIFS (à confirmer avec chaque banque).
// CI : taux de base « prêt personnel / consommation » relevés sur les plaquettes tarifaires 2025-2026
// (BICICI 8,5 %→13 % selon durée ; Coris 7,5 % fonctionnaires ; plafond d'usure BCEAO 15 %). Source : conditions de banque BCEAO S2 2025.
// Aucune adresse email n'est stockée ici : les demandes deviennent des leads
// traités par l'équipe Fodindin, pas envoyés automatiquement aux banques.
export const USURY_CAP = 0.15;
export const UEMOA_BANKS = {
  CI: [
    { name: "BICICI", rate: 0.089, fees: 0.02, note: "8,5 % (6-12 mois) a 13 % (37-60 mois), frais de dossier 2 %" },
    { name: "Coris Bank International", rate: 0.095, fees: 0.015, note: "7,5 % HT fonctionnaires, jusqu'a 120 mois" },
    { name: "SIB (Societe Ivoirienne de Banque)", rate: 0.099, fees: 0.015, note: "Pret personnel Attijariwafa" },
    { name: "Ecobank CI", rate: 0.088, fees: 0.02, note: "Pret personnel salarie" },
    { name: "NSIA Banque", rate: 0.095, fees: 0.015, note: "Prets etudes, equipement, vehicule" },
    { name: "SGCI (Societe Generale)", rate: 0.092, fees: 0.02, note: "Pret personnel ordinaire 18-60 mois" },
    { name: "BOA Cote d'Ivoire", rate: 0.098, fees: 0.015, note: "Pret personnel" },
    { name: "BNI", rate: 0.09, fees: 0.01, note: "Banque Nationale d'Investissement" },
    { name: "Banque Atlantique", rate: 0.102, fees: 0.02, note: "Pret personnel" },
    { name: "UBA Cote d'Ivoire", rate: 0.105, fees: 0.02, note: "Pret personnel" },
    { name: "Orabank CI", rate: 0.105, fees: 0.02, note: "Pret personnel" },
    { name: "Bridge Bank Group", rate: 0.109, fees: 0.02, note: "Pret personnel" },
    { name: "BGFIBank CI", rate: 0.108, fees: 0.02, note: "Pret personnel" },
    { name: "Stanbic Bank CI", rate: 0.11, fees: 0.02, note: "Pret personnel" },
  ],
  SN: [
    { name: "CBAO", rate: 0.09 },
    { name: "BICIS", rate: 0.088 },
    { name: "Ecobank SN", rate: 0.087 },
    { name: "Banque de l'Habitat", rate: 0.085 },
  ],
  ML: [
    { name: "BDM-SA", rate: 0.093 },
    { name: "BMS-SA", rate: 0.091 },
    { name: "Ecobank ML", rate: 0.089 },
  ],
  BF: [
    { name: "Coris Bank", rate: 0.088 },
    { name: "Bank of Africa BF", rate: 0.089 },
    { name: "Ecobank BF", rate: 0.086 },
  ],
  NE: [
    { name: "Bank of Africa NE", rate: 0.09 },
    { name: "Ecobank NE", rate: 0.088 },
  ],
  BJ: [
    { name: "Bank of Africa BJ", rate: 0.089 },
    { name: "Ecobank BJ", rate: 0.088 },
  ],
  TG: [
    { name: "Ecobank TG", rate: 0.087 },
    { name: "Orabank TG", rate: 0.09 },
  ],
};

export const COUNTRY_LABELS = {
  CI: "Côte d'Ivoire",
  SN: "Sénégal",
  ML: "Mali",
  BF: "Burkina Faso",
  NE: "Niger",
  BJ: "Bénin",
  TG: "Togo",
};

export const FINANCING_MIN_AMOUNT = 200000;

// Mensualité (formule d'amortissement classique). rate = taux annuel décimal.
export function monthlyPayment(principal, annualRate, months) {
  if (!principal || !months) return 0;
  const r = annualRate / 12;
  if (r === 0) return principal / months;
  return (principal * r) / (1 - Math.pow(1 + r, -months));
}
